class VfCardTrack extends HTMLElement {
  connectedCallback() {
    this.list = this.querySelector('.vf-track__list');
    this.items = [...this.list.children];
    this.current = this.querySelector('[data-current]');
    this.buttons = [...this.querySelectorAll('.vf-track__btn')];
    this.buttons.forEach((b) =>
      b.addEventListener('click', () => this.go(this.index() + Number(b.dataset.dir)))
    );
    this.list.addEventListener('scroll', () => this.update(), { passive: true });
    this.addEventListener('shopify:block:select', (e) => {
      const i = this.items.indexOf(e.target);
      if (i > -1) this.go(i);
    });
    this.update();
  }

  index() {
    const step = this.items[1] ? this.items[1].offsetLeft - this.items[0].offsetLeft : 1;
    return Math.round(this.list.scrollLeft / step);
  }

  go(i) {
    const target = this.items[Math.max(0, Math.min(this.items.length - 1, i))];
    if (target) this.list.scrollTo({ left: target.offsetLeft - this.list.offsetLeft, behavior: 'smooth' });
  }

  update() {
    if (!this.items.length) return;
    const nav = this.querySelector('.vf-track__nav');
    if (nav) nav.hidden = this.list.scrollWidth <= this.list.clientWidth + 4;
    const i = this.index();
    const atEnd = this.list.scrollLeft + this.list.clientWidth >= this.list.scrollWidth - 4;
    this.current.textContent = atEnd ? this.items.length : i + 1;
    this.buttons[0].disabled = i <= 0;
    this.buttons[1].disabled = atEnd;
  }
}

if (!customElements.get('vf-card-track')) customElements.define('vf-card-track', VfCardTrack);


/* Buyer-intent guard (Nov 4 2026). Once a visitor taps a buy control (Add to cart / Add to bag,
   Buy now / More payment options, the cart drawer's Check out), hide the Klaviyo welcome flyout for
   the rest of the session, including when they come back from checkout. The first real checkout
   on record (Nov 3) had the 20% popup land on the buyer as they left the product page. */
(() => {
  const KEY = 'vf_buyer';
  const mark = () => {
    document.documentElement.classList.add('vf-buyer');
    try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* storage blocked: class still applies */ }
  };
  try { if (sessionStorage.getItem(KEY)) mark(); } catch (e) { /* ignore */ }
  const BUY = '.shopify-payment-button, .accelerated-checkout-block, add-to-cart-component, vf-cart-add, .cart__checkout-button, [name="checkout"]';
  document.addEventListener('click', (e) => {
    if (e.target instanceof Element && e.target.closest(BUY)) mark();
  }, true);
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (f instanceof HTMLFormElement && (/\/cart\/add/.test(f.action) || f.id === 'cart-form' || f.closest('vf-cart-add'))) mark();
  }, true);
  // Wallet buttons (Shop Pay, PayPal) render in iframes, so their taps never bubble up. Catch the focus hand-off instead.
  window.addEventListener('blur', () => {
    const a = document.activeElement;
    if (a && a.tagName === 'IFRAME' && a.closest('.shopify-payment-button, .accelerated-checkout-block')) mark();
  });
  window.addEventListener('pageshow', (e) => {
    try { if (e.persisted && sessionStorage.getItem(KEY)) mark(); } catch (err) { /* ignore */ }
  });
})();
